import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "@/views/Login";
import Shows from "../views/Shows";
import Seasons from "../views/Seasons";
import Episodes from "../views/Episodes";

Vue.use(VueRouter);

const routes = [
    {
        path: '/login',
        name: 'login',
        component: Login,
    },
    {
        path: '/',
        name: 'shows',
        component: Shows,
        props: true,
    },
    {
        path: '/show',
        name: 'seasons',
        component: Seasons,
        props: true,
    },
    {
        path: '/season',
        name: 'episodes',
        component: Episodes,
        props: true,
    },
];

const router = new VueRouter({
    routes
});

export default router
